﻿import React from 'react';
import TabPanel from './TabPanel';

class ToggleList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activePanel: 0,
            tabCount: props.togglegroup.Toggles.length, 
            showToggle: props.togglegroup.ShowToggle
        };

        // For easy reference
        this.keys = {
            end: 35,
            home: 36,
            left: 37,
            up: 38,
            right: 39,
            down: 40,
            delete: 46
        };

        this.onTabClick = this.onTabClick.bind(this);
        this.onKeyDownEventListener = this.onKeyDownEventListener.bind(this);
        this.changeActivePanel = this.changeActivePanel.bind(this);
        this.setFocus = this.setFocus.bind(this);

    }

    changeActivePanel(index) {
        this.setFocus(index);
        this.setState({ activePanel: index });
    }

    onTabClick(e) {
        this.changeActivePanel(Number(e.target.dataset.index))
    }

    setFocus(index) {
        try {
            var nodeList = [...document.querySelectorAll('[role="tablist"] > [role="tab"]')];
            nodeList[index].focus();
        } catch (e) {
            console.log("Error", e);
        }
    }

    onKeyDownEventListener (event) {
        var key = event.keyCode;
        let currentIndex = this.state.activePanel;

        switch (key) {
          case this.keys.end:
            event.preventDefault();
            // Activate last tab
            this.changeActivePanel(this.state.tabCount - 1);
            break;
          case this.keys.home:
            event.preventDefault();
            // Activate first tab
            this.changeActivePanel(0);
            break;

          case this.keys.left:
            event.preventDefault();
            
            if(currentIndex === 0) {
                this.changeActivePanel(this.state.tabCount - 1);
            } else {
                var newIndex = currentIndex - 1;
                this.changeActivePanel(newIndex);
            }

          break;
          case this.keys.right:
              event.preventDefault();

              if(currentIndex === this.state.tabCount - 1) {
                this.changeActivePanel(0);
              } else {
                  var newIndex = currentIndex + 1;
                  this.changeActivePanel(newIndex);
              }

               break;
    
          // Up and down are in keydown
          // because we need to prevent page scroll >:)
          case this.keys.up:
          case this.keys.down:
            event.preventDefault();
            break;
        };

      

      };



    render() {

        return (
            <div>
                {
                    this.state.showToggle ? 
                    <div className="flex-container align-middle align-center toggle-group-wrapper">
                    {this.props.togglegroup.PreLabelToggle &&
                        <div className="toggle-group-label" id="preLabelToggle">
                            {this.props.togglegroup.PreLabelToggle}
                        </div>
                    }


                    <div className="flex-container align-middle align-center toggle-group-tabs" role="tablist" aria-labelledby="preLabelToggle">
                    {
                        this.props.togglegroup.Toggles.map(
                            (toggle, idx) => {

                                let cNames = "tab";
                                if(idx === this.state.activePanel) {
                                    cNames += " isActive"
                                }
                                if(toggle.IsBio) {
                                    cNames += " isBio"
                                }


                                return (
                                    <div role="tab" key={idx} 
                                        onClick={this.onTabClick} 
                                        onKeyDown={this.onKeyDownEventListener} 
                                        tabIndex={idx === this.state.activePanel ? '0' : '-1'}
                                        data-index={idx} 
                                        aria-selected={idx === this.state.activePanel ? 'true' : 'false'}
                                        className={cNames}>
                                        {toggle.Label}
                                    </div>
                                )
                            }
                        )
                    }
                    </div>
                </div>:null
                }

                
                {
                    this.props.togglegroup.Toggles.map(
                        (toggle, idx) => {
                            return (
                                <TabPanel 
                                    key={idx} 
                                    disclaimer={toggle.DisclaimerText} 
                                    columns={toggle.Columns} 
                                    isBio={toggle.IsBio}
                                    className={idx === this.state.activePanel ? 'toggle-group-panel stack-large isActive' : 'toggle-group-panel stack-large'} />
                            )
                        }
                    )
                }
                
            </div>
        )
    }
}

export default ToggleList;